import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import apiService from 'services/api'
import { SlideOutNavGroup, NavGroupItem } from './SlideOutNavGroup'

export const TargetsSlideOutContent: React.FC = () => {
  const api = apiService()
  const location = useLocation()
  const { data: companyCatAndSub, isLoading } =
    api.useGetActiveCompanyCategoriesAndTypes()

  // Transform API data into nav groups
  const categoryGroups = useMemo(() => {
    if (!companyCatAndSub) return []

    return companyCatAndSub.map((category) => {
      const items: NavGroupItem[] = category.sub_categories.map((sub) => ({
        label: sub.name,
        path: `/targets/${category.slug}/${sub.slug}/`,
      }))

      // Check if this category is active based on current path
      const isActiveGroup = location.pathname.includes(
        `/targets/${category.slug}/`
      )

      return {
        label: category.name,
        description: category.description || undefined,
        items,
        isActiveGroup,
        // Default expand the active group
        defaultExpanded: isActiveGroup,
      }
    })
  }, [companyCatAndSub, location.pathname])

  if (isLoading) {
    return (
      <div className="p-4 text-sm text-[#6e6e6e]">Loading categories...</div>
    )
  }

  if (!categoryGroups.length) {
    return (
      <div className="p-4 text-sm text-[#6e6e6e]">No categories available</div>
    )
  }

  return (
    <ul className="list-none m-0 p-0 flex flex-col gap-1.5">
      {categoryGroups.map((group) => (
        <SlideOutNavGroup
          key={group.label}
          label={group.label}
          description={group.description}
          items={group.items}
          section="targets"
          defaultExpanded={group.defaultExpanded}
          isActiveGroup={group.isActiveGroup}
          keepOpen
        />
      ))}
    </ul>
  )
}
